import React from "react";
import { Spinner } from "../../../../common/spinner";
import { withFormsy } from "formsy-react";
import Messages from "../../../../../configurations/messages";

class DuplicateTransactions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.formData[props.name]
    };
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue = event => {
    const value = event.target.value;
    this.props.setValue(value);
    this.setState({ value });
  };

  render() {
    const {
      fetchingDuplicateTransactions,
      duplicateTransactions,
      getDuplicateTransactions,
      disableFields,
      name,
      isRecurrent,
      isDuplicate
    } = this.props;
    return (
      <div>
        {fetchingDuplicateTransactions ? (
          <div className="text-center">
            <Spinner
              size="100px"
              message={`Fetching ${
                isDuplicate
                  ? "duplicate transactions"
                  : isRecurrent
                  ? "recurrent payments"
                  : ""
              }...`}
            />
          </div>
        ) : duplicateTransactions.length ? (
          <div>
            {duplicateTransactions.length <= 1 && isDuplicate ? (
              <div className="alert alert-danger">
                No{" "}
                {isDuplicate
                  ? "duplicate transactions"
                  : isRecurrent
                  ? "recurrent payments"
                  : ""}{" "}
                found. Please select another reason/motive code to proceed
              </div>
            ) : (
              <h4 className="bold">
                {isDuplicate && "Select an original transaction from the table"}
                {isRecurrent && "Recurrent transactions"}
              </h4>
            )}
            <div className="table-responsive duplicate-transaction-table">
              <table className="table table-hover table-bordered table-condensed ">
                <thead>
                  <tr>
                    <th />
                    <th>PAN</th>
                    <th>Transaction Date</th>
                    <th>Merchant</th>
                    <th>Terminal ID</th>
                    <th>STAN</th>
                    <th>Transaction Amount</th>
                    <th>Settlement Amount</th>
                    <th>Scheme Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {duplicateTransactions.map((transaction, index) => (
                    <tr key={index}>
                      <td>
                        {isDuplicate && (
                          <label>
                            <input
                              type="radio"
                              id={`duplicate${index}`}
                              name={name}
                              className="form-check-input"
                              value={transaction["transactionReference"]}
                              onChange={this.changeValue}
                              checked={
                                this.state.value ===
                                transaction["transactionReference"]
                              }
                              disabled={
                                disableFields ||
                                duplicateTransactions.length <= 1
                              }
                            />
                            <span className={`lbl`}>&nbsp;</span>
                          </label>
                        )}
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.pan}
                        </label>
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.transactionDate}
                        </label>
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.merchant}
                        </label>
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.terminalId}
                        </label>
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.stan}
                        </label>
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.transactionAmount}
                        </label>
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.settlementAmount}
                        </label>
                      </td>
                      <td>
                        <label htmlFor={`duplicate${index}`}>
                          {transaction.schemeAmount}
                        </label>
                      </td>
                    </tr>
                  ))}
                  <tr />
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="text-center">
            <h4 className="bold text-danger">
              {Messages.ERROR_DUPLICATE_TRANSACTIONS}
            </h4>
            <p>
              No duplicate transactions to process.{" "}
              <span className="text-danger">Cannot proceed</span>
            </p>
            <button
              className="btn btn-danger"
              onClick={getDuplicateTransactions}
            >
              Try again
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default withFormsy(DuplicateTransactions);



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/CreateCaseForms/DuplicateTransactions.js